import { EXTENSION_PREVIEW_SKIP_BTN_CLASS_FACTORY } from "../../conf";
import { RENDER_EXTENSION_PREVIEW } from "./renderExtension";

const renderExtensionCustomPost = ({ title, text, imgUrl, dismissText }) => {
  return RENDER_EXTENSION_PREVIEW(`
        <div
            style="
                --x-color-canvas: rgb(255, 255, 255);
                --x-color-canvas-subdued: rgb(250, 250, 250);
                --x-color-canvas-text: rgb(88, 88, 88);
                --x-color-canvas-text-subdued: rgb(119, 119, 119);
                --x-color-canvas-text-emphasized: rgb(64, 51, 49);
                --x-color-canvas-border: rgb(230, 230, 230);
                --x-color-canvas-border-emphasized: rgb(64, 51, 49);
                --x-color-surface-primary: rgb(255, 255, 255);
                --x-color-surface-primary-disabled: rgb(248, 248, 248);
                --x-color-surface-primary-subdued: rgb(250, 250, 250);
                --x-color-surface-primary-text: rgb(88, 88, 88);
                --x-color-surface-primary-text-subdued: rgb(119, 119, 119);
                --x-color-surface-primary-text-emphasized: rgb(64, 51, 49);
                --x-color-surface-primary-border: rgb(230, 230, 230);
                --x-color-surface-primary-border-emphasized: rgb(64, 51, 49);
                --x-color-surface-secondary: rgb(250, 250, 250);
                --x-color-surface-secondary-disabled: rgb(243, 243, 243);
                --x-color-surface-secondary-subdued: rgb(245, 245, 245);
                --x-color-surface-secondary-text: rgb(84, 84, 84);
                --x-color-surface-secondary-text-subdued: rgb(115, 115, 115);
                --x-color-surface-secondary-text-emphasized: rgb(61, 47, 45);
                --x-color-surface-secondary-border: rgb(225, 225, 225);
                --x-color-surface-secondary-border-emphasized: rgb(61, 47, 45);
                --x-color-primary-action: rgb(24, 120, 185);
                --x-color-primary-action-hovered: rgb(17, 95, 147);
                --x-color-primary-action-pressed: rgb(17, 95, 147);
                --x-color-primary-action-text: rgb(237, 244, 255);
                --x-color-primary-action-text-hovered: rgb(17, 95, 147);
                --x-color-primary-action-text-pressed: rgb(17, 95, 147);
                --x-color-interactive-text: rgb(24, 120, 185);
                --x-color-interactive-text-hovered: rgb(32, 146, 224);
                --x-color-interactive-text-pressed: rgb(32, 146, 224);
                --x-color-critical-accent: rgb(226, 33, 32);
                --x-typography-primary-fonts: -apple-system, BlinkMacSystemFont,
                    'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', sans-serif;
                --x-typography-primary-weight-bold: 500;
                --x-typography-secondary-fonts: -apple-system, BlinkMacSystemFont,
                    'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', sans-serif;
                --x-typography-secondary-weight-bold: -apple-system, BlinkMacSystemFont,
                    'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
            "
        >
            <div class="_1_8iO _2z1C3">
                <div class="_1vAUS xfmA9">
                    <div class="_1vAUS">
                        <div class="_1vAUS"><div class=""></div></div>
                        <style>
                            @media all and (max-width: 749px) {
                                .Layout71 > ._3_xXQ > :nth-child(1) {
                                    flex: 0 0 100%;
                                    max-width: 100%;
                                }
                                .Layout71 > ._3_xXQ {
                                    flex-wrap: wrap;
                                }
                                .Layout71 > ._3_xXQ {
                                    max-width: 90%;
                                }
                            }
                            @media all and (min-width: 750px) and (max-width: 1199px) {
                                .Layout71 > ._3_xXQ > :nth-child(1) {
                                    flex: 0 0 100%;
                                    max-width: 100%;
                                }
                                .Layout71 > ._3_xXQ {
                                    flex-wrap: wrap;
                                }
                                .Layout71 > ._3_xXQ {
                                    max-width: 80%;
                                }
                            }
                            @media all and (min-width: 1200px) {
                                .Layout71 > ._3_xXQ > :nth-child(1) {
                                    flex: 0 0 100%;
                                    max-width: 100%;
                                }
                                .Layout71 > ._3_xXQ {
                                    flex-wrap: wrap;
                                }
                                .Layout71 > ._3_xXQ {
                                    max-width: 100rem;
                                }
                            }
                        </style>
                        <div class="_1Jrax Layout71">
                            <div class="_3_xXQ">
                                <div class="_2WN_- _1NH3k _3KkOT">
                                    <div class="">
                                        <button
                                            type="button"
                                            class="_2pOWh TGOUV _1omM3"
                                            aria-busy="false"
                                            aria-live="polite"
                                        >
                                            <span class="_9I39O"
                                                ><style>
                                                    .Layout72 > ._3_xXQ {
                                                        max-width: 25rem;
                                                    }
                                                </style>
                                                <div class="_1Jrax Layout72">
                                                    <div class="_3_xXQ">
                                                        <img
                                                            src="https://coopcommerce.s3.us-west-1.amazonaws.com/pp-extension/order-confirmation.png"
                                                            alt=""
                                                            class="_1vnYn"
                                                        />
                                                    </div></div
                                            ></span>
                                        </button>
                                    </div>
                                    <button
                                        type="button"
                                        class="_2pOWh TGOUV _1omM3 ${EXTENSION_PREVIEW_SKIP_BTN_CLASS_FACTORY(
                                          "x"
                                        )}"
                                        aria-busy="false"
                                        aria-live="polite"
                                    >
                                        <span class="_9I39O"
                                            ><style>
                                                .Layout73 > ._3_xXQ {
                                                    max-width: 5.4rem;
                                                }
                                            </style>
                                            <div class="_1Jrax Layout73">
                                                <div class="_3_xXQ">
                                                    <img
                                                        src="https://coopcommerce.s3.us-west-1.amazonaws.com/pp-extension/cross-btn.png"
                                                        alt=""
                                                        class="_1vnYn"
                                                    />
                                                </div></div
                                        ></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="_1vAUS">
                        <div class="_1vAUS"><div class=""></div></div>
                        <style>
                            @media all and (max-width: 749px) {
                                .Layout74 > ._3_xXQ > :nth-child(1) {
                                    flex: 0 0 100%;
                                    max-width: 100%;
                                }

                                .Layout74 > ._3_xXQ > :nth-child(2) {
                                    flex: 0 0 0%;
                                    max-width: 0%;
                                }

                                .Layout74 > ._3_xXQ > :nth-child(3) {
                                    flex: 0 0 98%;
                                    max-width: 98%;
                                }
                                .Layout74 > ._3_xXQ {
                                    flex-wrap: wrap;
                                }
                                .Layout74 > ._3_xXQ {
                                    max-width: 90%;
                                }
                            }
                            @media all and (min-width: 750px) and (max-width: 1199px) {
                                .Layout74 > ._3_xXQ > :nth-child(1) {
                                    flex: 0 0 46%;
                                    max-width: 46%;
                                }

                                .Layout74 > ._3_xXQ > :nth-child(2) {
                                    flex: 0 0 8%;
                                    max-width: 8%;
                                }

                                .Layout74 > ._3_xXQ > :nth-child(3) {
                                    flex: 0 0 46%;
                                    max-width: 46%;
                                }
                                .Layout74 > ._3_xXQ {
                                    max-width: 80%;
                                }
                            }
                            @media all and (min-width: 1200px) {
                                .Layout74 > ._3_xXQ > :nth-child(1) {
                                    flex: 0 0 46%;
                                    max-width: 46%;
                                }

                                .Layout74 > ._3_xXQ > :nth-child(2) {
                                    flex: 0 0 8%;
                                    max-width: 8%;
                                }

                                .Layout74 > ._3_xXQ > :nth-child(3) {
                                    flex: 0 0 46%;
                                    max-width: 46%;
                                }
                                .Layout74 > ._3_xXQ {
                                    max-width: 100rem;
                                }
                            }
                        </style>
                        <div class="_1Jrax Layout74">
                            <div class="_3_xXQ">
                                <img
                                    src="${imgUrl}"
                                    alt=""
                                    class="_1vnYn"
                                />
                                <div class=""></div>
                                <div class="_1vAUS">
                                    <strong class="_2AqiW _1jmYs _2u7Wg _3cD2S"
                                        >${title}</strong
                                    >
                                    <p class="_1BPaF">
                                        ${text}
                                    </p>
                                    <div class="_1vAUS">
                                        <div class=""></div>
                                        <div class=""></div>
                                    </div>
                                    <button
                                        type="button"
                                        class="_2pOWh TGOUV ${EXTENSION_PREVIEW_SKIP_BTN_CLASS_FACTORY(
                                          0
                                        )}"
                                        aria-busy="false"
                                        aria-live="polite"
                                    >
                                        <span class="_9I39O">${dismissText}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="_1vAUS"><div class=""></div></div>
                    <div class="_1vAUS">
                        <div class="_1vAUS">
                            <div class=""></div>
                            <div class=""></div>
                        </div>
                        <style>
                            @media all and (max-width: 749px) {
                                .Layout75 > ._3_xXQ > :nth-child(1) {
                                    flex: 0 0 100%;
                                    max-width: 100%;
                                }
                                .Layout75 > ._3_xXQ {
                                    flex-wrap: wrap;
                                }
                                .Layout75 > ._3_xXQ {
                                    max-width: 90%;
                                }
                            }
                            @media all and (min-width: 750px) and (max-width: 1199px) {
                                .Layout75 > ._3_xXQ > :nth-child(1) {
                                    flex: 0 0 100%;
                                    max-width: 100%;
                                }
                                .Layout75 > ._3_xXQ {
                                    flex-wrap: wrap;
                                }
                                .Layout75 > ._3_xXQ {
                                    max-width: 80%;
                                }
                            }
                            @media all and (min-width: 1200px) {
                                .Layout75 > ._3_xXQ > :nth-child(1) {
                                    flex: 0 0 100%;
                                    max-width: 100%;
                                }
                                .Layout75 > ._3_xXQ {
                                    flex-wrap: wrap;
                                }
                                .Layout75 > ._3_xXQ {
                                    max-width: 100rem;
                                }
                            }
                        </style>
                        <div class="_1Jrax Layout75">
                            <div class="_3_xXQ">
                                <div
                                    class="_1yitZ _2z6Td"
                                    role="status"
                                    aria-atomic="true"
                                    aria-live="polite"
                                >
                                    <div class="_2WN_-">
                                        <div class="_2U5PX qG4ms">
                                            <div>
                                                <div class="">
                                                    Powered by
                                                    <a
                                                        class="_2pOWh TGOUV _1omM3"
                                                        href="http://consumer.disconetwork-staging.com/core/extension_collective_click/?publisher=ediths-mansion&amp;checkout_token=21be6c463ed0019369af3ad061c253ec"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        ><span class="_9I39O"
                                                            >Disco</span
                                                        ></a
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `);
};

export default renderExtensionCustomPost;
